import { useCallback, useMemo } from 'react';
import { useGetCurrentPage } from '../../../../app/get-current-page';
import type { IAlertData } from '../../../../dotcms/dotcms-models/dotcms-alert';
import { useGetTheme } from '../../../../hooks/use-get-theme';
import useAlertsStorage from './use-alerts-storage';

const useAlertBannersBox = () => {
  const theme = useGetTheme();
  const alertsStorage = useAlertsStorage();
  const page = useGetCurrentPage();
  const alerts = useMemo(
    () => (page ? alertsStorage.get(page) : []),
    [alertsStorage, page],
  );
  const closeAlert = useCallback(
    (alert: IAlertData) => alertsStorage.remove(alert),
    [alertsStorage],
  );

  return {
    theme,
    alerts,
    closeAlert,
  };
};

export default useAlertBannersBox;
